const ApiUrl = {
    API_URL: "https://api.kaay.pk/api/",
    API_URL_Artncraft: "https://api.kaay.pk/api/artncraft",
    API_URL_Bookmark: "https://api.kaay.pk/api/bookmark",
    API_URL_Brand: "https://api.kaay.pk/api/brand",
    API_URL_BrandListing: "https://api.kaay.pk/api/BrandListing",
    API_URL_BrandUpdate: "https://api.kaay.pk/api/brandupdate",
    API_URL_BrandYoumayknow: "https://api.kaay.pk/api/BrandYoumayknow",
    API_URL_BrandYoumayknowDelete: "https://api.kaay.pk/api/BrandYoumayknowDelete",
    API_URL_Business: "https://api.kaay.pk/api/business",
    API_URL_Changepassword: "https://api.kaay.pk/api/Changepassword",
    API_URL_ChatMessage: "https://api.kaay.pk/api/ChatMessage",
    API_URL_ChatRooms: "https://api.kaay.pk/api/ChatRooms",
    API_URL_Collection: "https://api.kaay.pk/api/collection",
    API_URL_CollectionUpdate: "https://api.kaay.pk/api/collectionupdate",
    API_URL_Color: "https://api.kaay.pk/api/Color",
    API_URL_ColorUpdate: "https://api.kaay.pk/api/ColorUpdate",
    API_URL_Comments: "https://api.kaay.pk/api/Comments",
    API_URL_CommentDelete: "https://api.kaay.pk/api/CommentDelete",
    API_URL_CommentsLike: "https://api.kaay.pk/api/CommentLike",
    API_URL_Condition: "https://api.kaay.pk/api/Condition",
    API_URL_ConditionUpdate: "https://api.kaay.pk/api/ConditionUpdate",
    API_URL_DiscountCode: "https://api.kaay.pk/api/DiscountCode",
    API_URL_DiscountCodeUpdate: "https://api.kaay.pk/api/DiscountCodeUpdate",
    API_URL_Feeds: "https://api.kaay.pk/api/Feeds",
    API_URL_File: "https://api.kaay.pk/api/File",
    API_URL_Filter: "https://api.kaay.pk/api/Filter",
    API_URL_Follower: "https://api.kaay.pk/api/Follower",
    API_URL_FollowList: "https://api.kaay.pk/api/FollowList",
    API_URL_Fulfillment: "https://api.kaay.pk/api/Fulfillment",
    API_URL_Hashtag: "https://api.kaay.pk/api/Hashtag",
    API_URL_HashtagFilter: "https://api.kaay.pk/api/HashtagFilter",
    API_URL_Home: "https://api.kaay.pk/api/Home",
    API_URL_HomeYMK: "https://api.kaay.pk/api/HomeYMK",
    API_URL_Insights: "https://api.kaay.pk/api/Insights",
    API_URL_Intrust: "https://api.kaay.pk/api/Intrust",
    API_URL_IntrustLastUsed: "https://api.kaay.pk/api/IntrustLastUsed",
    API_URL_IntrustUpdate: "https://api.kaay.pk/api/IntrustUpdate",
    API_URL_Kaaycloset: "https://api.kaay.pk/api/kaaycloset",
    API_URL_Like: "https://api.kaay.pk/api/Like",
    API_URL_Liked: "https://api.kaay.pk/api/Liked",
    API_URL_ListCollection: "https://api.kaay.pk/api/ListCollection",
    API_URL_ListCollectionListing: "https://api.kaay.pk/api/ListCollectionListing",
    API_URL_ListCollectionsLatest: "https://api.kaay.pk/api/ListCollectionsLatest",
    API_URL_ListCollectionUpdate: "https://api.kaay.pk/api/ListCollectionUpdate",
    API_URL_ListingAdmin: "https://api.kaay.pk/api/ListingAdmin",
    API_URL_ListingActive: "https://api.kaay.pk/api/ListingActive",
    API_URL_ListingCollection: "https://api.kaay.pk/api/ListingCollection",
    API_URL_Listing: "https://api.kaay.pk/api/Listing",
    API_URL_ListingDelete: "https://api.kaay.pk/api/ListingDelete",
    API_URL_ListingEditUserInfo: "https://api.kaay.pk/api/ListingEditUserInfo",
    API_URL_ListingNCollection: "https://api.kaay.pk/api/ListingNCollection",
    API_URL_ListingPin: "https://api.kaay.pk/api/ListingPin",
    API_URL_ListingProfileGrid: "https://api.kaay.pk/api/ListingProfileGrid",
    API_URL_ListingRecommend: "https://api.kaay.pk/api/ListingRecommend",
    API_URL_ListingSold: "https://api.kaay.pk/api/ListingSold",
    API_URL_ListingState: "https://api.kaay.pk/api/ListingState",
    API_URL_ListingType: "https://api.kaay.pk/api/ListingType",
    API_URL_ListingTypeUpdate: "https://api.kaay.pk/api/ListingTypeUpdate",
    API_URL_ListingUpdate: "https://api.kaay.pk/api/ListingUpdate",
    API_URL_ListingUser: "https://api.kaay.pk/api/ListingUser",
    API_URL_Location: "https://api.kaay.pk/api/Location",
    API_URL_LocationUpdate: "https://api.kaay.pk/api/LocationUpdate",
    API_URL_MobileVerification: "https://api.kaay.pk/api/MobileVerification",
    API_URL_Newonkaay: "https://api.kaay.pk/api/newonkaay",
    API_URL_Navigation: "https://api.kaay.pk/api/Navigation",
    API_URL_NavigationUpdate: "https://api.kaay.pk/api/NavigationUpdate",
    API_URL_Notification: "https://api.kaay.pk/api/Notification",
    API_URL_OAuth: "https://api.kaay.pk/api/OAuth",
    API_URL_Orders: "https://api.kaay.pk/api/Orders073",
    API_URL_OrdersUn: "https://api.kaay.pk/api/OrdersUn073",
    API_URL_OrdersUser: "https://api.kaay.pk/api/OrdersUser",
    API_URL_Page: "https://api.kaay.pk/api/Page",
    API_URL_PageDelete: "https://api.kaay.pk/api/PageDelete",
    API_URL_Profile: "https://api.kaay.pk/api/Profile",
    API_URL_RecentlyViewed: "https://api.kaay.pk/api/RecentlyViewed",
    API_URL_Reels: "https://api.kaay.pk/api/Reels",
    API_URL_Search: "https://api.kaay.pk/api/Search",
    API_URL_SearchProduct: "https://api.kaay.pk/api/SearchProduct",
    API_URL_SearchScreen: "https://api.kaay.pk/api/SearchScreen",
    API_URL_SearchScreenDelete: "https://api.kaay.pk/api/SearchScreenDelete",
    API_URL_SearchScreenItem: "https://api.kaay.pk/api/SearchScreenItems",
    API_URL_SearchScreenItemDelete: "https://api.kaay.pk/api/SearchScreenItemsDelete",
    API_URL_Suggestions: "https://api.kaay.pk/api/Suggestions",
    API_URL_Tickets: "https://api.kaay.pk/api/Tickets",
    API_URL_TopHashtag: "https://api.kaay.pk/api/TopHashtag",
    API_URL_TopHashtagDelete: "https://api.kaay.pk/api/TopHashtagDelete",
    API_URL_TopSearch: "https://api.kaay.pk/api/TopSearch",
    API_URL_TopSearchDelete: "https://api.kaay.pk/api/TopSearchDelete",
    API_URL_TopSeller: "https://api.kaay.pk/api/TopSeller",
    API_URL_TopSellerDelete: "https://api.kaay.pk/api/TopSellerDelete",
    API_URL_TopSellerSelect: "https://api.kaay.pk/api/TopSellerSelect",
    API_URL_User: "https://api.kaay.pk/api/User",
    API_URL_UserList: "https://api.kaay.pk/api/UserList",
    API_URL_Image_Thumbnail: "https://api.kaay.pk/api/img/thumbnail/",
    API_URL_Image_Collection: "https://api.kaay.pk/api/img/collection/",
    API_URL_Image_HD: "https://api.kaay.pk/api/img/hd/",
    API_URL_Video_HD: "https://api.kaay.pk/api/video/hd/",
    API_URL_VideoFile: "https://api.kaay.pk/api/VideoFile"
};
export default ApiUrl